import React from 'react';
import { Menu } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import LocaleSwitcher from './LocaleSwitcher';

function ZenSignHeader() {
  const logoUrl = useSelector((state) => state.auth.user.logoUrl);
  return (
    <div className="ui top menu">
      {logoUrl && (
        <Menu.Item>
          <img className="ui left attached logo image" src={`${logoUrl}`} alt="Client Logo" />
        </Menu.Item>
      )}
      <Menu.Item position="right">
        <LocaleSwitcher />
        <img className="ui right attached logo image" src="/zensignPlaceholder.png" alt="ZenQMS Logo" />
      </Menu.Item>
    </div>
  );
}

export default ZenSignHeader;
